/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import cx from 'classnames';
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import FileSaver from 'file-saver';
import {
  Icon,
  Modal,
  Header,
  Popup,
  PopupHeader,
  PopupContent,
} from 'semantic-ui-react';
import Chart from 'chart.js/auto';
import { observer, inject } from 'mobx-react';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import DeleteModal from '../Modal/DeleteModal';
import ExportModal from '../Modal/ExportModal';
import MoveFileModal from '../Modal/MoveFileModal';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import VexGenerator from '../SBOM/VexGenerator';
import NISModal from '../NISTools/NISModal';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import {
  //SCANS_LABEL_ARCHIVE,
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import './OverviewProjectCard.css';
import moreBtn from '../../images/components/content_project_card/newRisk.png';
import normalBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Version) (normal).png';
import activeBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Version) (active).png';
import compareBtn from '../../images/icons/compare.png';
import moveFileIcon from '../../images/components/content_project_card/move-file-icon.svg';
//import historyIcon from '../../images/components/content_project_card/history-icon.svg';
import deleteIcon from '../../images/components/content_project_card/delete-icon.svg';
import exportIcon from '../../images/components/content_project_card/export-icon.svg';
import quickScan from '../../images/components/content_project_card/quickScan.png';
import ScanInfoModal from '../Modal/ScanInfoModal';
import SecurityRiskUpdatedModal from '../Modal/SecurityRiskUpdatedModal';

class OverviewProjectCard extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.state = {
      isOpen: false,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isOpenMFM: false,
      isMovingFile: false,
      isOpenMSI: false,
      isOpenMSU: false,
      movingData: {},
      projectList: props.projectList,
      isSelectable: props.isSelectable,
      checkValues: props.checkValues,
      isOpenAlertModal: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMNA: false,
      isShowSbom: false,
      isOpenMVX: false,
      toExport: '',
      activeMenuIndex: '',
      isOpenMCB: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleCardBookmarkChange = this.handleCardBookmarkChange.bind(this);
    this.handleCardVersionBookmarkChange = this.handleCardVersionBookmarkChange.bind(this);
    this.setCompareItem = this.setCompareItem.bind(this);
    this.closeExportModal = this.closeExportModal.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.deletedCallback = this.deletedCallback.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.closeMoveFileModal = this.closeMoveFileModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleInfoItem = this.handleInfoItem.bind(this);
    this.handleSecurityInfoItem = this.handleSecurityInfoItem.bind(this);
    this.handleLeakageList = this.handleLeakageList.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSpdx = this.handleSpdx.bind(this);
    this.handleCycloneDx = this.handleCycloneDx.bind(this);
    this.handleNIASbom = this.handleNIASbom.bind(this);
    this.handleVexBom = this.handleVexBom.bind(this);
    this.handleSlideToggle = this.handleSlideToggle.bind(this);
    this.handleMoreMenu = this.handleMoreMenu.bind(this);
    this.setFileMove = this.setFileMove.bind(this);
    this.handleCBOM = this.handleCBOM.bind(this);
  }

  componentDidMount() {
    if (this.miniBarChart) {
      this.drawMiniBarChart();
    }
    if (this.bubbleChart) {
      this.drawBubbleChart();
    }
    if (this.pieChart) {
      this.drawChart();
    }
    //this.renderPopup();
    $(document).on('mouseover', '.content_project_card .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { file, isSelectable, checkValues } = this.props;
    if (prevProps.file.component_count.total !== file.component_count.total) {
      this.drawChart();
    }
    if (isSelectable) {
      if (prevProps.isSelectable !== isSelectable) {
        this.setState({
          isSelectable,
        });
      }
    }
    if (checkValues) {
      if (prevProps.checkValues !== checkValues) {
        this.setState({
          checkValues,
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleInfoItem = () => {
    this.setState({
      isOpenMSI: true,
    });
  };

  handleSecurityInfoItem = () => {
    this.setState({
      isOpenMSU: true,
    });
  };

  handleClick = () => {
    const { file, clickEvent } = this.props;
    clickEvent(file.uploaded_file_id);
  };

  handleDelete = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleExport = () => {
    this.setState({
      modalExportIsOpen: true,
    });
  };

  handleCBOM() {
    const { file, translate } = this.props;
    const { has_crypto } = file;

    if (has_crypto) {
      this.setState({
        isOpenMCB: true,
      });
    } else {
      this.modalAction = translate('modal.title.notice');
      this.modalBody = translate('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  }

  handleSpdx = () => {
    this.setState({
      isOpenMCX: true,
    });
  };

  handleCycloneDx = () => {
    this.setState({
      isOpenMCD: true,
    });
  };

  handleVexBom = () => {
    this.setState({
      isOpenMVX: true,
    });
  };

  handleNIASbom = () => {
    this.setState({
      isOpenMNA: true,
    });
  };

  handleClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleClickOutside = (event) => {
    const { activeMenuIndex } = this.state;
    const container = $('.content_project_card');
    if (container && container.has(event.target).length === 0) {
      if (activeMenuIndex !== '') {
        this.setState({
          isShowSbom: false,
          activeMenuIndex: '',
        });
      }
    }
  };

  handleSlideToggle = () => {
    const { isShowSbom } = this.state;
    this.setState({
      isShowSbom: !isShowSbom,
    });
  };

  handleMoreMenu = () => {
    const { file } = this.props;
    const { uploaded_file_id } = file;
    const { activeMenuIndex } = this.state;
    if (activeMenuIndex === uploaded_file_id) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    } else {
      this.setState({
        activeMenuIndex: uploaded_file_id,
        isShowSbom: false,
      });
    }
  };

  setFileMove(obj, id) {
    const { updateFilePath } = this.props;
    this.setState({
      isMovingFile: true,
    }, () => {
      api.setFileMove({
        selected_project_id: obj.selectedProject.id,
        selected_project_version_id: obj.selectedProjectVersion.id,
      }, id)
        .then(() => {
          this.setState({
            isMovingFile: false,
            isOpenMFM: false,
          });
          updateFilePath(obj, id);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  setCompareItem() {
    const { setCompareItem, file } = this.props;
    setCompareItem(file);
  }

  handleCheckChange = (e) => {
    const { file, isSelectable, handleCheckChange } = this.props;
    if (!isSelectable || !file.has_manage_permission) {
      return;
    }
    handleCheckChange(e, { value: file.uploaded_file_id });
  };

  handleChangeView = (e, string) => {
    const { file, handleChangeView } = this.props;
    handleChangeView(file.uploaded_file_id, string);
  };

  handleCardVersionBookmarkChange = (e, pvid) => {
    const { cardIndex, handleCardVersionBookmarkChange } = this.props;
    const projectVersionId = pvid;
    api.toggleBookmark(
      {
        project_version_id: projectVersionId,
        view_point: 'overview',
      }
    )
      .then((response) => {
        const res = response.response;
        handleCardVersionBookmarkChange(cardIndex, projectVersionId, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleCardBookmarkChange = (e, ufid) => {
    const { handleCardBookmarkChange, cardIndex } = this.props;
    api.toggleBookmark(
      {
        uploaded_file_id: ufid,
        view_point: 'overview',
      }
    )
      .then((response) => {
        const res = response.response;
        handleCardBookmarkChange(cardIndex, ufid, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleMove = () => {
    const { file } = this.props;
    const { projectList } = this.state;
    const findProjectIndex = projectList.findIndex((item) => {
      return item.pid === file.project_id;
    });

    const findVersionGroup = projectList[findProjectIndex].upLoaded.filter((item) => {
      return item.project_version_id === file.project_version_id;
    });

    const rowData = {
      name: file.name,
      projectName: projectList[findProjectIndex].projectName,
      projectVersionName: findVersionGroup[0].project_version_name,
      uploaded_file_id: file.uploaded_file_id,
      project_id: file.project_id,
    };

    this.setState({
      movingData: rowData,
      isOpenMFM: true,
    });
  };

  handleLeakageList = () => {
    const { file, handleLeakageList } = this.props;
    handleLeakageList(file.uploaded_file_id, file.name);
  };

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  closeModal() {
    this.setState({
      isOpenMSI: false,
      isOpenMSU: false,
      isOpenAlertModal: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMVX: false,
      isOpenMNA: false,
      isOpenMCB: false,
    });
  }

  closeExportModal() {
    this.setState({
      modalExportIsOpen: false,
      isDownloadingReport: false,
      toExport: '',
    });
  }

  closeMoveFileModal() {
    this.setState({
      isOpenMFM: false,
    });
  }

  drawChart() {
    const { file } = this.props;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const config = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [
              file.component_count.has_risk,
              file.component_count.total - file.component_count.has_risk,
            ],
            backgroundColor: ['#ff7d45', '#F4F4F4'],
            borderWidth: [0, 0],
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        animation: {
          animationRotate: true,
          animateScale: true,
        },
      },
    };

    const ctx = this.pieChart.getContext('2d');
    //ctx.width = '50px';
    //ctx.height = '50px';
    this.chart = new Chart(ctx, config);
  }

  drawMiniBarChart() {
    const { file } = this.props;
    const realData = file.security_count;
    const dummyData = cloneDeep(realData);
    delete dummyData.total;

    const arr = Object.keys(dummyData).map((i) => {
      return dummyData[i];
    });
    const indexOfMax = this.findMaxIndex(arr);
    if (arr[indexOfMax] !== 0) {
      const dataRatio = arr.map((value) => {
        return (value / arr[indexOfMax]) * 100;
      });
      let i = 0;
      for (i; i < this.miniBarChart.childNodes.length; i++) {
        this.miniBarChart.childNodes[i].style.width = `${dataRatio[i]}%`;
      }
    }
  }

  drawBubbleChart() {
    const { file } = this.props;
    const realData = file.license_count;
    if (realData.total !== 0) {
      const dummyData = cloneDeep(realData);
      delete dummyData.total;
      const array = Object.keys(dummyData).map((i) => {
        return dummyData[i];
      });

      const indexOfMax = this.findMaxIndex(array);
      const indexOfMin = this.findMinIndex(array);
      let duplicateMax;
      let duplicateMin;

      //duplicate check
      array.filter((item, index) => {
        if (index !== indexOfMax && array[index] === array[indexOfMax]) {
          duplicateMax = index;
          return duplicateMax;
        }
        return false;
      });

      array.filter((item, index) => {
        if (index !== indexOfMin && array[index] === array[indexOfMin]) {
          duplicateMin = index;
          return duplicateMin;
        }
        return false;
      });

      if (duplicateMax) {
        let otherIdx;
        array.filter((item, index) => {
          if (index !== indexOfMax && index !== duplicateMax) {
            otherIdx = index;
            return otherIdx;
          }
          return false;
        });
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[duplicateMax].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[duplicateMax].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.height = '50%';
      } else if (duplicateMin) {
        let otherIdx;
        array.filter((item, index) => {
          if (index !== indexOfMin && index !== duplicateMin) {
            otherIdx = index;
            return otherIdx;
          }
          return false;
        });
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[duplicateMin].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[duplicateMin].childNodes[0].style.height = '50%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.height = '50%';
      } else if (indexOfMax === null && indexOfMin === null) {
        this.bubbleChart.childNodes[0].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[0].childNodes[0].style.height = '75%';
        this.bubbleChart.childNodes[1].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[1].childNodes[0].style.height = '75%';
        this.bubbleChart.childNodes[2].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[2].childNodes[0].style.height = '75%';
      } else {
        let otherIdx;
        array.filter((item, index) => {
          if (index !== indexOfMin && index !== indexOfMax) {
            otherIdx = index;
            return otherIdx;
          }
          return false;
        });
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.width = '100%';
        this.bubbleChart.childNodes[indexOfMax].childNodes[0].style.height = '100%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.width = '75%';
        this.bubbleChart.childNodes[otherIdx].childNodes[0].style.height = '75%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.width = '50%';
        this.bubbleChart.childNodes[indexOfMin].childNodes[0].style.height = '50%';
      }
    } else {
      this.bubbleChart.childNodes[0].childNodes[0].style.width = '50%'; // red
      this.bubbleChart.childNodes[0].childNodes[0].style.height = '50%';
      this.bubbleChart.childNodes[1].childNodes[0].style.width = '50%'; //orange
      this.bubbleChart.childNodes[1].childNodes[0].style.height = '50%';
      this.bubbleChart.childNodes[2].childNodes[0].style.width = '50%'; //yellow
      this.bubbleChart.childNodes[2].childNodes[0].style.height = '50%';
    }
  }

  findMaxIndex(arr) {
    const allEqual = arr.every((item) => {
      return item === arr[0];
    });
    if (allEqual) {
      return null;
    }
    const maxValue = Math.max(...arr);
    const maxIndex = arr.findIndex((value) => {
      return maxValue === value;
    });
    return maxIndex;
  }

  findMinIndex(arr) {
    const allEqual = arr.every((item) => {
      return item === arr[0];
    });
    if (allEqual) {
      return null;
    }
    const minValue = Math.min(...arr);
    const minIndex = arr.findIndex((value) => {
      return minValue === value;
    });
    return minIndex;
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  downloadReport(exportFormat, exportType, toExport) {
    const { state, file, translate } = this.props;
    const { currentPrecisionLevel } = state.user;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };

    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${
        file.uploaded_file_id
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${
        file.uploaded_file_id
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true,
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        if (file.precisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (file.precisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = file.precisionLevel;
        }
        const fileName = `${file.name}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = translate('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = translate('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{translate('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{translate('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = translate('modal.message.export_send_email');
          this.modalHeader = translate('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = translate('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = translate('modal.title.attention');

        if (!o.error) {
          this.modalBody = translate('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = translate('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = translate('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = translate('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = translate('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });

      });
  }

  deletedCallback() {
    const { deletedCallback } = this.props;
    deletedCallback();
  }

  render() {
    const humanReadable = (seconds) => {
      const pad = (x) => {
        return x < 10 ? '0'.concat(x) : ''.concat(x);
      };
      return pad(parseInt(seconds / (60 * 60), 10)).concat(
        ':',
        pad(parseInt((seconds / 60) % 60, 10)),
        ':',
        pad(seconds % 60)
      ); // eslint-disable-line no-unused-vars
    };

    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    const {
      file,
      projectName,
      translate,
      state,
    } = this.props;
    const {
      has_leakage,
      use_scan_option,
      uploaded_file_id
    } = file;
    const {
      isSelectable,
      checkValues,
      isOpen,
      isMovingFile,
      isOpenMSI,
      isOpenMSU,
      isOpenMFM,
      isDownloadingReport,
      modalExportIsOpen,
      movingData,
      isOpenAlertModal,
      toExport,
      isOpenMCX,
      isOpenMCD,
      isOpenMNA,
      isShowSbom,
      activeMenuIndex,
      isOpenMVX,
      isOpenMCB,
    } = this.state;

    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        //userSelect: 'none',
        //background: isDragging && '#fae7ff',
        opacity: isDragging && 0.6,
        ...draggableStyle,
      };
    };

    return (
      <div
        className={cx(
          'content_project_card_box',
          {
            version_group: file.project_version_name,
          },
        )}
      >
        <div
          className={cx(
            'content_project_card',
            {
              select_mode: isSelectable,
            },
            {
              active: checkValues.indexOf(uploaded_file_id) > -1,
            },
            {
              more_menu_show: activeMenuIndex === uploaded_file_id
            }
          )}
          ref={this.props.draggableProvided.innerRef}
          {...this.props.draggableProvided.draggableProps}
          {...this.props.draggableProvided.dragHandleProps}
          style={getItemStyle(
            this.props.draggableSnapshot.isDragging,
            this.props.draggableProvided.draggableProps.style
          )}
          onClick={this.handleCheckChange}
          onKeyUp={this.handleCheckChange}
        >
          <div className="content_project_card_inner">
            {
              checkValues.indexOf(uploaded_file_id) > -1
              && <span className="active_mode"><Icon name="check" /></span>
            }
            <div className="content_project_card_header">
              {
                file.component_count_broad.total !== 0 ? (
                  <div
                    className="name has_link"
                    onClick={this.handleClick}
                    onKeyUp={this.handleClick}
                  >
                    { use_scan_option ? (<img src={quickScan} alt="" />) : null}
                    <span>{file.name}</span>
                  </div>
                ) : (
                  <div
                    className="name"
                    style={{ color: '#b9b9b9' }}
                  >
                    { use_scan_option ? (<img src={quickScan} alt="" />) : null}
                    <span>{file.name}</span>
                  </div>
                )
              }
              <div
                className="more"
                onClick={this.handleMoreMenu}
                onKeyUp={this.handleMoreMenu}
              >
                <a>
                  <img src={moreBtn} alt="more" />
                </a>
              </div>
              <div className="more_menu">
                {file.is_security_rescanned ? (
                  <p className="noti">
                    <a onClick={this.handleSecurityInfoItem} onKeyUp={this.handleSecurityInfoItem}>
                      <Icon name="info circle" />
                      {translate('card.menu.security_risk_updated')}
                    </a>
                  </p>
                ) : null}
                <ul>
                  <li>
                    <a onClick={this.handleInfoItem} onKeyUp={this.handleInfoItem}>
                      <Icon name="info" style={{ color: '#969696' }} />
                      {translate('card.menu.information')}
                    </a>
                  </li>
                  {
                    has_leakage ? (
                      <li>
                        <a onClick={this.handleLeakageList} onKeyUp={this.handleLeakageList}>
                          <Icon name="shield" style={{ color: '#969696' }} />
                          {translate('card.menu.leakage')}
                        </a>
                      </li>
                    ) : null
                  }
                  <li>
                    {
                      file.component_count_broad.total > 0 ? (
                        <a onClick={this.setCompareItem} onKeyUp={this.setCompareItem}>
                          <img src={compareBtn} alt="" />
                          {translate('card.menu.compare')}
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <img src={compareBtn} alt="" />
                          {translate('card.menu.compare')}
                        </a>
                      )
                    }
                  </li>
                  {/**
                  <li>
                    <a onClick={this.props.bookMark}>
                      <img src={bookmarkIcon} alt="" />
                      Bookmark
                    </a>
                  </li>
                  <li>
                    <a onClick={this.history}>
                      <img src={historyIcon} alt="" />
                      History
                    </a>
                  </li>
                   */}
                  <li>
                    {
                      file.has_manage_permission ? (
                        <a onClick={this.handleMove} onKeyUp={this.handleMove}>
                          <img src={moveFileIcon} alt="" />
                          {translate('card.menu.move')}
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <img src={moveFileIcon} alt="" />
                          {translate('card.menu.move')}
                        </a>
                      )
                    }
                  </li>
                  <li>
                    {
                      file.component_count_broad.total === 0 ? (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <Icon name="bookmark outline" style={iconStyle} />
                          {translate('card.menu.bookmark')}
                        </a>
                      ) : (
                        <a
                          onClick={(e) => { return this.handleCardBookmarkChange(e, file.uploaded_file_id); }}
                          onKeyUp={(e) => { return this.handleCardBookmarkChange(e, file.uploaded_file_id); }}
                        >
                          {
                            file.is_bookmark ? (
                              <Icon name="bookmark" style={iconStyle} />
                            ) : (
                              <Icon name="bookmark outline" style={iconStyle} />
                            )
                          }
                          {translate('card.menu.bookmark')}
                        </a>
                      )
                    }
                  </li>
                  {
                    state.user.use_crypto ? (
                      <li>
                        <a
                          onClick={this.handleCBOM}
                          onKeyUp={this.handleCBOM}
                        >
                          <Icon name="download" style={iconStyle} />
                          CBOM
                        </a>
                      </li>
                    ) : null
                  }
                  <li>
                    <a
                      className="sbom"
                      onClick={this.handleSlideToggle}
                      onKeyUp={this.handleSlideToggle}
                    >
                      <img src={exportIcon} alt="" />
                      SBOM
                    </a>
                    <ul
                      className={cx(
                        'sub_menu',
                        {
                          active: isShowSbom,
                        },
                      )}
                    >
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleExport}
                          onKeyUp={this.handleExport}
                        >
                          <Icon name="download" style={iconStyle} />
                          {translate('card.menu.clarity')}
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleSpdx}
                          onKeyUp={this.handleSpdx}
                        >
                          <Icon name="download" style={iconStyle} />
                          {translate('card.menu.spdx')}
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleCycloneDx}
                          onKeyUp={this.handleCycloneDx}
                        >
                          <Icon name="download" style={iconStyle} />
                          CycloneDX
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleVexBom}
                          onKeyUp={this.handleVexBom}
                        >
                          <Icon name="download" style={iconStyle} />
                          VEX
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleNIASbom}
                          onKeyUp={this.handleNIASbom}
                        >
                          <Icon name="download" style={iconStyle} />
                          NIS
                        </a>
                      </li>
                    </ul>

                  </li>
                  <li>
                    {file.has_manage_permission ? (
                      <a onClick={this.handleDelete} onKeyUp={this.handleDelete}>
                        <img src={deleteIcon} alt="" />
                        {translate('card.menu.delete')}
                      </a>
                    ) : (
                      <a
                        style={{
                          cursor: 'default',
                          backgroundColor: '#cccccc',
                        }}
                      >
                        <img src={deleteIcon} alt="" />
                        {translate('card.menu.delete')}
                      </a>
                    )}
                  </li>
                </ul>
              </div>
              <div
                className={cx(
                  'version',
                  {
                    bookmark_version: file.project_version_name,
                  },
                )}
              >
                {file.project_version_name}
                <a
                  className="version_bookmark_button"
                  onClick={(e) => { return this.handleCardVersionBookmarkChange(e, file.project_version_id); }}
                  onKeyUp={(e) => { return this.handleCardVersionBookmarkChange(e, file.project_version_id); }}
                >
                  {
                    file.project_version_is_bookmark ? (
                      <img src={activeBookmarkImg} alt="" className="active" />
                    ) : (
                      <img src={normalBookmarkImg} alt="" className="normal" />
                    )
                  }
                </a>
              </div>
            </div>
            <div className="content_project_card_content">
              <div className="content_project_card_content_inner">
                <div
                  className="card_content"
                >
                  {
                    file.component_count_broad.total !== 0 ? (
                      <div
                        className="card_content_item has_link"
                        onClick={this.handleClick}
                        onKeyUp={this.handleClick}
                      >
                        <p className="label">{translate('card.menu.grade')}</p>
                        {
                          file.uploaded_grade === '-' ? (
                            <div className="rank">{file.uploaded_grade}</div>
                          ) : (
                            <Popup
                              className="grade_info"
                              trigger={<div className="rank">{file.uploaded_grade}</div>}
                              inverted
                            >
                              <PopupHeader>
                                <Icon name="info circle" />
                                {file.uploaded_grade === 'A' && translate('panel.menu.info_grade_a_title')}
                                {file.uploaded_grade === 'B' && translate('panel.menu.info_grade_b_title')}
                                {file.uploaded_grade === 'C' && translate('panel.menu.info_grade_c_title')}
                                {file.uploaded_grade === 'D' && translate('panel.menu.info_grade_d_title')}
                              </PopupHeader>
                              <PopupContent>
                                {file.uploaded_grade === 'A' && translate('panel.menu.info_grade_a')}
                                {file.uploaded_grade === 'B' && translate('panel.menu.info_grade_b')}
                                {file.uploaded_grade === 'C' && translate('panel.menu.info_grade_c')}
                                {file.uploaded_grade === 'D' && translate('panel.menu.info_grade_d')}
                              </PopupContent>
                            </Popup>
                          )
                        }
                      </div>
                    ) : (
                      <div
                        className="card_content_item"
                        style={{ pointerEvents: 'none' }}
                      >
                        <p className="label">{translate('card.menu.grade')}</p>
                        <div className="rank">{file.uploaded_grade}</div>
                      </div>
                    )
                  }
                  {
                    file.security_count_broad.total !== 0 ? (
                      <div
                        className="card_content_item has_link"
                        onClick={(e) => { return this.handleChangeView(e, 'security'); }}
                        onKeyUp={(e) => { return this.handleChangeView(e, 'security'); }}
                      >
                        <p className="label">{translate('card.menu.security')}</p>
                        <div className="mini_bar_chart_wrap">
                          <p className="value">
                            {this.abbreviateNumber(file.security_count.total)}
                            {file.has_exploit ? (<Icon name="bug" />) : null}
                          </p>
                          <div
                            className="mini_bar_chart"
                            ref={(ref) => {
                              this.miniBarChart = ref;
                            }}
                          >
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="card_content_item"
                        style={{ pointerEvents: 'none' }}
                      >
                        <p className="label">{translate('card.menu.security')}</p>
                        <div className="mini_bar_chart_wrap">
                          <p className="value">
                            {this.abbreviateNumber(file.security_count.total)}
                            {file.has_exploit ? (<Icon name="bug" />) : null}
                          </p>
                          <div
                            className="mini_bar_chart"
                            ref={(ref) => {
                              this.miniBarChart = ref;
                            }}
                          >
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                            <div style={{ width: '0%' }} />
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {
                    file.component_count_broad.total !== 0 ? (
                      <div
                        className="card_content_item has_link"
                        onClick={(e) => { return this.handleChangeView(e, 'component'); }}
                        onKeyUp={(e) => { return this.handleChangeView(e, 'component'); }}
                      >
                        <p className="label">{translate('card.menu.component')}</p>
                        <div className="pie_chart_wrap">
                          <span className="value">
                            {this.abbreviateNumber(file.component_count.total)}
                          </span>
                          <canvas
                            ref={(ref) => {
                              this.pieChart = ref;
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="card_content_item"
                        style={{ pointerEvents: 'none' }}
                      >
                        <p className="label">{translate('card.menu.component')}</p>
                        <div className="pie_chart_wrap">
                          <span className="value">
                            {this.abbreviateNumber(file.component_count.total)}
                          </span>
                          <canvas
                            ref={(ref) => {
                              this.pieChart = ref;
                            }}
                          />
                        </div>
                      </div>
                    )
                  }
                  {
                    file.license_count_broad.total !== 0 ? (
                      <div
                        className="card_content_item has_link"
                        onClick={(e) => { return this.handleChangeView(e, 'license'); }}
                        onKeyUp={(e) => { return this.handleChangeView(e, 'license'); }}
                      >
                        <p className="label">{translate('card.menu.license_uppercase')}</p>
                        <div className="mini_bubble_chart_wrap">
                          <p className="value">
                            {this.abbreviateNumber(file.license_count.total)}
                          </p>
                          <div
                            className="bubble_chart"
                            ref={(ref) => {
                              this.bubbleChart = ref;
                            }}
                          >
                            <div>
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                            <div>
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                            <div>
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="card_content_item"
                        style={{ pointerEvents: 'none' }}
                      >
                        <p className="label">{translate('card.menu.license_uppercase')}</p>
                        <div className="mini_bubble_chart_wrap">
                          <p className="value">
                            {this.abbreviateNumber(file.license_count.total)}
                          </p>
                          <div
                            className="bubble_chart"
                            ref={(ref) => {
                              this.bubbleChart = ref;
                            }}
                          >
                            <div>
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                            <div>
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                            <div>
                              <div className="inner" style={{ width: '0%', height: '0%' }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }

                  <div className="bottom_value_wrap">
                    {file.policy_count_broad !== 0 ? (
                      <div
                        className="left_value value purpple"
                        onClick={(e) => { return this.handleChangeView(e, 'policy'); }}
                        onKeyUp={(e) => { return this.handleChangeView(e, 'policy'); }}
                      >
                        {file.policy_count}
                        <em>{translate('card.menu.policy')}</em>
                      </div>
                    ) : (
                      <div className="left_value value grey">
                        {file.policy_count}
                        <em>{translate('card.menu.policy')}</em>
                      </div>
                    )}
                    <div className="right_value value grey">
                      {humanReadable(file.report_scan_time)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="content_project_card_footer">
              <p className="time">{file.uploaded_at}</p>
              <p className="name">{file.owner}</p>
            </div>
          </div>
        </div>
        <DeleteModal
          isOpen={isOpen}
          closeModal={this.handleClose}
          rowData={file}
          deletedCallback={this.deletedCallback}
          translate={translate}
        />
        <ExportModal
          isOpenMED={modalExportIsOpen}
          onClose={this.closeExportModal}
          handleModal={this.downloadReport}
          isDownloading={isDownloadingReport}
          birdView
          rowData={file}
          translate={translate}
        />
        <MoveFileModal
          isOpenMFM={isOpenMFM}
          closeModal={this.closeMoveFileModal}
          rowData={movingData}
          isMovingFile={isMovingFile}
          setFileMove={this.setFileMove}
          projectName={projectName}
          translate={translate}
        />
        <ScanInfoModal
          isOpenMSI={isOpenMSI}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <SecurityRiskUpdatedModal
          isOpenMSU={isOpenMSU}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <SPDXDocumentGenerator
          isOpenMCX={isOpenMCX}
          reportId={file.uploaded_file_id}
          uploadedFileName={file.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CycloneDXDocumentGenerator
          isOpenMCD={isOpenMCD}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <VexGenerator
          isOpenMVX={isOpenMVX}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <NISModal
          isOpenMNA={isOpenMNA}
          reportId={file.uploaded_file_id}
          translate={translate}
          closeModal={this.closeModal}
        />
        <CBOMGenerator
          isOpenMCB={isOpenMCB}
          reportId={file.uploaded_file_id}
          fileName={file.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                {
                  toExport === 's3' ? (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      {this.modalHeader}
                      {this.modalSubBody}
                    </Modal.Description>
                  ) : (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      <p className="modal_list">{this.modalHeader}</p>
                      <p>{this.modalSubBody}</p>
                    </Modal.Description>
                  )
                }

                <div className="button_wrap">
                  <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
OverviewProjectCard.defaultProps = {
  file: {},
};

export default WithRouter(inject('state')(observer(OverviewProjectCard)));
